export default __webpack_public_path__ + "static/media/chrome-logo.5d2fdbc5.svg";